/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './device_code';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "external": {
            "nested": {
              "GetBatchDeviceCodesRequest": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "GetBatchDeviceCodesResponse": {
                "fields": {
                  "deviceCode": {
                    "type": ".squareup.devicesettings.external.DeviceCode",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.external?.nested?.GetBatchDeviceCodesRequest && !$root.nested?.squareup?.nested?.devicesettings?.nested?.external?.nested?.GetBatchDeviceCodesResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetBatchDeviceCodesRequest @ squareup/devicesettings/external/device_code_get_batch.proto at 13:1
 */
export const GetBatchDeviceCodesRequest = $root.lookupType('squareup.devicesettings.external.GetBatchDeviceCodesRequest');
fixType(GetBatchDeviceCodesRequest);
Builder.createAndAttachToType(GetBatchDeviceCodesRequest);
/**
 * SOURCE GetBatchDeviceCodesResponse @ squareup/devicesettings/external/device_code_get_batch.proto at 20:1
 */
export const GetBatchDeviceCodesResponse = $root.lookupType('squareup.devicesettings.external.GetBatchDeviceCodesResponse');
fixType(GetBatchDeviceCodesResponse);
Builder.createAndAttachToType(GetBatchDeviceCodesResponse);